(function ($, Drupal) {
  'use strict';

  function is_touch_device() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function (query) {
      return window.matchMedia(query).matches;
    }

    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
  }

  $(document).ready(function () {
    var targets = $('[rel~=tooltip]'),
        target = false,
        tooltip = false,
        title = false;
    var temper = 0;

    if (is_touch_device()) {
      targets.bind('click', function (e) {
        if (temper <= 0) {
          temper++;
          e.preventDefault();
          return false;
        }
      });
    }
    
    targets.bind('mouseenter', function (e) {

      target = $(this);
      var tip = target.attr('title');
      tooltip = $('<div id="tooltip"></div>');

      if (!tip || tip == '')
        return false;

      target.removeAttr('title');
      tooltip.css('opacity', 0)
          .html(tip)
          .appendTo('body');

      var init_tooltip = function () {
        if ($(window).width() < tooltip.outerWidth() * 1.5)
          tooltip.css('max-width', $(window).width() / 2);
        else
          tooltip.css('max-width', 340);

        var pos_left = target.offset().left + ( target.outerWidth() / 2 ) - ( tooltip.outerWidth() / 2 ),
            pos_top = target.offset().top - tooltip.outerHeight() - 20;

        if (pos_left < 0) {
          pos_left = target.offset().left + target.outerWidth() / 2 - 20;
          tooltip.addClass('left');
        }
        else
          tooltip.removeClass('left');

        if (pos_left + tooltip.outerWidth() > $(window).width()) {
          pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20;
          tooltip.addClass('right');
        }
        else
          tooltip.removeClass('right');

        if (pos_top < 0) {
          var pos_top = target.offset().top + target.outerHeight();
          tooltip.addClass('top');
        }
        else
          tooltip.removeClass('top');

        tooltip.css({left: pos_left, top: pos_top})
            .animate({top: '+=10', opacity: 1}, 50);
      };

      init_tooltip();
      $(window).resize(init_tooltip);

      var remove_tooltip = function () {
        tooltip.animate({top: '-=10', opacity: 0}, 50, function () {
          $(this).remove();
        });

        target.attr('title', tip);
        temper = 0;
      };

      target.bind('mouseleave', remove_tooltip);
      tooltip.bind('click', remove_tooltip);

    });
  });
})(jQuery, Drupal);